import { Pressable } from '../../primitives/Pressable';
import { Text } from '../../primitives/Text';
import { disabledDimStyle } from '../../utils/disabledDim';

export interface SignInTextLinkProps {
  /** Pre-translated — the DS carries no i18n. */
  label: string;
  onPress: () => void;
  /** Blocks the press (and dims the line) while an auth request is in flight. */
  disabled?: boolean;
}

/**
 * The card's inline text link — "Forgot password?" and the ready state of
 * "Resend code". B2 medium in `primary-600`, announced as a button, dimmed by
 * style while busy. The DS `Button` has no link variant, so the two sign-in
 * blocks share this one instead of each drawing its own.
 */
export function SignInTextLink({ label, onPress, disabled }: SignInTextLinkProps) {
  const dim = disabledDimStyle(disabled);
  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      accessibilityRole="button"
      webProps={{ type: 'button', style: dim }}
      nativeProps={{ style: dim }}>
      <Text className="text-b2 font-medium text-primary-600 native:font-mona-medium">
        {label}
      </Text>
    </Pressable>
  );
}
(SignInTextLink as { displayName?: string }).displayName = 'SignInTextLink';
